module.exports = __webpack_public_path__ + "img/D201604_1.b42071cf.jpg";